export const Messages = Object.freeze({
  UPDATE: "{item} was withdrawn successfully",
  UPDATE_FAQ: "{item} was updated successfully",
  UPDATE_FAILURE: "Oops system failed to update {item}, please try again later",
  ADD_SUCCESS: "{item} was created successfully",
  ADD_FAILURE: "Oops system failed to add {item}, please try again later",
  DELETE_SUCCESS: "{item} deletion was successful",
  DISABLE_SUCCESS: "{item} was successful",
  DELETE_FAILURE: "Oops system failed to delete {item}, please try again later",
  DISABLE_FAILURE: "Oops system failed to disable {item}, please try again later",
  GET_SUCCESS: "{item} was retrieved successfully",
  GET_FAILURE: "Oops system failed to retrieve {item}, please try again",
  UPDATE_STATUS: "{item} was {status} successfully",
  UPDATE_STATUS_ASSIGN: "{item} was assigned successfully",
  UPDATE_FAILURE_STATUS:"Oops system failed to update {item}, please try again",
  UPDATE_SUCCESS: "{item} was updated successfully",
  UPDATE_SUCCESSWITHOK:
    "{item} was updated successfully" +
    "\n" +
    "but your changes will only take effect on your next login",
  UPDATE_FAILURE: "Oops system failed to update {item}, please try again",
  UPDATE_CANCELLED: "",
  EXIST_UPDATE_FAILURE:
    "Oops system failed to update {item}, record already exist",
  EXIST_ADD_FAILURE: "Oops system failed to add {item}, record already exist",
  USER_REQUEST_FAILURE: "Something is incorrect with front-end input",
  SERVER_REQUEST_FAILURE: "Server failed to process your request, try again",
  USER_EXISTS: "Provided email is already in use, Please use a different email",
  EMAIL_SEND_SUCCESS: "Email was sent successfully to {item}",
  EMAIL_SEND_FAILURE: "Oops! system failed to send email to {item}",
  INVALID_EMAIL_DOMAIN: "Email syntax or domain is invalid",
  INVALID_TOKEN_EXPIRES: "Unauthorised, invalid or expired token",
  UNAUTHORISED: "Unauthorised access, due to user rights",
  FILE_UPLOAD_NO_FILE: "Oops no file was selected for upload",
  FILEUPLOAD_SUCCESS: "{item} was uploaded successfully",
  FILEUPLOAD_FAILURE:
    "Oops system failed to upload {item}, please try again later",
  FILEUPLOAD_FAILURE_SIZE:
    "System failed to upload {item}, file records seem to exceeds the limit of 100K records/rows",
  FILEDOWNLOAD_SUCCESS: "{item} was downloaded successfully",
  FILEDOWNLOAD_FAILURE:
    "Oops system failed to download {item}, please try again later",
  LOG_FAILURE: "Oops system failed to retrieve {item}, please try again later",
  NO_DATA: "No data was retrieved for {item}",
  CONFLICT: "Error: {item} already exists in the system",
  NOT_EXIST_FOR_INSERT: "{item} does not exist, it may be inserted"
});

export const Notify = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  DESTROY: "destroy",
});
